import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  root: {
    paddingVertical: 10,
  },
  totalContainer: {
    paddingVertical: 10,
  },
  totalBeforeVatText: theme => ({
    fontSize: 16,
    color: theme.colors.textColorTwo,
  }),
  vatText: theme => ({
    fontSize: 16,
    color: theme.colors.textColorTwo,
  }),
  totalPayText: theme => ({
    fontSize: 16,
    color: theme.colors.textColorTwo,
    ...Fonts.type.bold,
  }),
});
